import React, { forwardRef } from "react";

const Badge = forwardRef(({ className = "", ...props }, ref) => (
  <span ref={ref} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 ${className}`} {...props} />
));

export default Badge; 